import { css } from 'lit';

export default [
  css`
  .table-container {
    display: block;
    width: 100%;
    overflow-x: auto;
  }

  .table {
    border-spacing: 0px;
    width: 100%;
  }

  a,
  a:visited {
    color: var(--tenable-link-color, #0079dd);
    text-decoration: var(--tenable-link-decoration, none);
  }

  .tenable-header-row {
    border-bottom: var(--tenable-table-header-border, 1px solid #ccc);
  }


  th {
    color: var(--tenable-table-header-text-color, #425363);
    padding: var(--tenable-table-header-row-padding, .5rem 1rem);
    text-align: var(--tenable-teable-header-text-align, left);
  }

  .sort-chervon {
    display: inline-block;
    vertical-align: -.1rem;
  }

  .table-header-sort {
    cursor: pointer;
  }

  .table-body {
    td {
      padding: var(--tenable-table-padding, 1.5rem 1rem);
      border-top: var(--tenable-table-row-border, 1px solid #ccc);
    }
  }

  .override-cell {
    color: var(--tenable-table-override-text-color, #0079dd);
  }

  .table-hover-highlight {
    .table-body {
      tr:hover {
        background-color: var(--tenable-table-hover-color, #0079dd);
        color: var(--tenable-table-text-hover-color, #fff);

        a,
        a:visited {
          color: var(--tenable-table-link-hover-color, var(--tenable-table-text-hover-color, #fff));
          text-decoration: var(--tenable-link-decoration, none);
        }

        .override-cell {
          color: var(--tenable-table-text-hover-color, #fff);
        }
      }
    }
  }


  .table-clickable-row {
    .table-body {
      td {
        padding: 0;

        a {
          display: flex;
          padding: var(--tenable-table-padding, 1.5rem 1rem);
          color: var(--tenable-text-color, #425363);
        }
      }

      tr:hover {
        cursor: pointer;
      }
    }
  }
  `,
];
